export enum PrescriptionsTypeEnum {
  PatientOnly = 'PatientOnly',
  ExpressPharmacy = 'ExpressPharmacy',
  SelectedPharmacy = 'SelectedPharmacy',
}
